import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CharLength } from '../../../../modules/directives/char-length.directive';

@Component({
  selector: 'app-business-info-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CharLength],
  templateUrl: './business-info-step.component.html',
})
export class BusinessInfoStepComponent {
  @Input({ required: true }) group!: FormGroup;
  @Input() busyAsin = false;
  @Input() busyCac = false;
  @Input() readOnly = false;
  @Input() mdas: Array<{ id: string; name: string }> = [];
  @Input() categories: Array<{ id: string; name: string }> = [];
  @Output() validateAsin = new EventEmitter<void>();
  @Output() verifyCac = new EventEmitter<void>();

  requiresAsinValidation: boolean = true;

  hasError(controlName: string): boolean {
    const control = this.group?.get(controlName);
    return !!control && control.invalid && (control.touched || control.dirty);
  }

}
